import React from 'react';
import get from 'lodash/get';
import FeatureCheck from '@components/common/FeatureCheck';
import DashboardTabs from '@components/common/Dashboard/DashboardTabs';
import { PAGE_TYPE } from '@utils/constants';
import { CheckerPanel } from './styled';
import { useParams } from 'react-router-dom';

const NocFeatureCheck = (props: { pageType?: keyof typeof PAGE_TYPE }) => {
  const { pageType } = props;
  const { id:currentShareId = 'noc' } = useParams();
  return (
    <CheckerPanel>
      <DashboardTabs pageType={pageType} id={currentShareId} />
      <FeatureCheck />
    </CheckerPanel>
  );
};

export default NocFeatureCheck;
